import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStudentMedicalBenefitsTugo = (state) => state.get('studentMedicalBenefitsTugo');

const makeSelectStudentMedicalBenefitsTugo = () => createSelector(
  selectStudentMedicalBenefitsTugo,
  (StudentMedicalBenefitsTugoState) => ({

    whatExpensesAreYouClaimingFor: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      []
    ),

    // Doctor Visit selectors
    doctorVisitTelemedicine: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitTelemedicine']),
      ''
    ),
    doctorVisitByPhone: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitByPhone']),
      false
    ),
    doctorVisitInPerson: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitInPerson']),
      false
    ),
    doctorVisitAnnualPhysicalExam: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitAnnualPhysicalExam']),
      ''
    ),
    doctorVisitFirstVisit: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFirstVisit']),
      ''
    ),
    doctorVisitFollowUp: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUp']),
      ''
    ),
    doctorVisitFollowUpFracture: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitFollowUpFracture']),
      ''
    ),
    doctorVisitSTIVaccinationsTBEyeExam: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitSTIVaccinationsTBEyeExam']),
      false
    ),
    doctorVisitSTITesting: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitSTITesting']),
      false
    ),
    doctorVisitVaccinationsTBTesting: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitVaccinationsTBTesting']),
      false
    ),
    doctorVisitEyeExamination: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'doctorVisitEyeExamination']),
      false
    ),
    infoAnnualPhysicalExamItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoAnnualPhysicalExamItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoAnnualPhysicalExamItems']).toJS(),
      []
    ),
    infoOutpatientPhysicianFeesItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']).toJS(),
      []
    ),
    infoFollowUpVisitItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpVisitItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpVisitItems']).toJS(),
      []
    ),
    infoFollowUpFractureItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpFractureItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoFollowUpFractureItems']).toJS(),
      []
    ),
    infoSTITestingItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoSTITestingItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoSTITestingItems']).toJS(),
      []
    ),
    infoVaccinationsTBTestingItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoVaccinationsTBTestingItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoVaccinationsTBTestingItems']).toJS(),
      []
    ),
    infoEyeExaminationItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoEyeExaminationItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoEyeExaminationItems']).toJS(),
      []
    ),
    infoTelemedicineItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoTelemedicineItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoTelemedicineItems']).toJS(),
      []
    ),

    // Diagnostic Tests selectors
    infoDiagnosticTestsItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoDiagnosticTestsItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoDiagnosticTestsItems']).toJS(),
      []
    ),

    // Prescription Drugs selectors
    infoPrescriptionDrugsItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionDrugsItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionDrugsItems']).toJS(),
      []
    ),

    // Ambulance Services selectors
    ambulanceGroundService: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'ambulanceGroundService']),
      ''
    ),
    ambulanceAirService: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'ambulanceAirService']),
      ''
    ),
    infoGroundAmbulanceItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoGroundAmbulanceItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoGroundAmbulanceItems']).toJS(),
      []
    ),
    infoAirAmbulanceItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoAirAmbulanceItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoAirAmbulanceItems']).toJS(),
      []
    ),

    // Hospitalization selectors
    hospitalizationHospitalInvoice: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalInvoice']),
      ''
    ),
    hospitalizationPhysicianInvoice: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationPhysicianInvoice']),
      ''
    ),
    hospitalizationLabDiagnostic: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationLabDiagnostic']),
      ''
    ),
    hospitalizationOtherRelated: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOtherRelated']),
      ''
    ),
    hospitalizationMentalHealthPsychiatric: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMentalHealthPsychiatric']),
      false
    ),
    hospitalizationEmergencyAirTransportation: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationEmergencyAirTransportation']),
      false
    ),
    hospitalizationAirfareReturnHome: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationAirfareReturnHome']),
      false
    ),
    hospitalizationFamilyTransportation: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportation']),
      false
    ),
    hospitalizationMedicalAttendant: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalAttendant']),
      false
    ),
    infoHospitalFeesItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoHospitalFeesItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoHospitalFeesItems']).toJS(),
      []
    ),
    infoInpatientPhysicianFeesItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']).toJS(),
      []
    ),
    infoXrayLabsDiagnosticsItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']).toJS(),
      []
    ),
    infoOtherHospitalizationItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoOtherHospitalizationItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoOtherHospitalizationItems']).toJS(),
      []
    ),
    infoMentalHealthPsychiatricItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoMentalHealthPsychiatricItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoMentalHealthPsychiatricItems']).toJS(),
      []
    ),
    infoEmergencyAirTransportationItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoEmergencyAirTransportationItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoEmergencyAirTransportationItems']).toJS(),
      []
    ),
    infoAirfareReturnHomeItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoAirfareReturnHomeItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoAirfareReturnHomeItems']).toJS(),
      []
    ),
    infoFamilyTransportationItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationItems']).toJS(),
      []
    ),
    infoMedicalAttendantItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoMedicalAttendantItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoMedicalAttendantItems']).toJS(),
      []
    ),

    // Essential Medical Appliances selectors
    infoEssentialMedicalAppliancesItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoEssentialMedicalAppliancesItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoEssentialMedicalAppliancesItems']).toJS(),
      []
    ),
    returnOfVehicleCommercialAgency: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleCommercialAgency']),
      false
    ),
    returnOfVehicleFamilyMemberFriend: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleFamilyMemberFriend']),
      false
    ),
    infoReturnOfVehicleCommercialAgencyItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleCommercialAgencyItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleCommercialAgencyItems']).toJS(),
      []
    ),
    infoReturnOfVehicleFamilyMemberFriendItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleFamilyMemberFriendItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleFamilyMemberFriendItems']).toJS(),
      []
    ),

    // Private Duty Nursing selectors
    infoPrivateDutyNursingItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrivateDutyNursingItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrivateDutyNursingItems']).toJS(),
      []
    ),

    // Fracture Treatment selectors
    infoFractureTreatmentItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoFractureTreatmentItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoFractureTreatmentItems']).toJS(),
      []
    ),

    // Maternity Benefits selectors
    maternityBenefitsDateOfConception: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsDateOfConception']),
      ''
    ),
    maternityBenefitsAnticipatedDueDate: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsAnticipatedDueDate']),
      ''
    ),
    maternityBenefitsRoutinePreNatalCare: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsRoutinePreNatalCare']),
      false
    ),
    maternityBenefitsComplicationsOfPregnancy: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsComplicationsOfPregnancy']),
      false
    ),
    maternityBenefitsInvoluntaryTermination: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'maternityBenefitsInvoluntaryTermination']),
      false
    ),
    infoRoutinePreNatalCareItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoRoutinePreNatalCareItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoRoutinePreNatalCareItems']).toJS(),
      []
    ),
    infoComplicationsOfPregnancyItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoComplicationsOfPregnancyItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoComplicationsOfPregnancyItems']).toJS(),
      []
    ),
    infoInvoluntaryTerminationItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoInvoluntaryTerminationItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoInvoluntaryTerminationItems']).toJS(),
      []
    ),

    // Professional Services selectors
    professionalServicesPhysiotherapist: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPhysiotherapist']),
      false
    ),
    professionalServicesChiropractor: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropractor']),
      false
    ),
    professionalServicesChiropodist: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropodist']),
      false
    ),
    professionalServicesOsteopath: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesOsteopath']),
      false
    ),
    professionalServicesPodiatrist: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPodiatrist']),
      false
    ),
    professionalServicesAcupuncturist: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesAcupuncturist']),
      false
    ),
    professionalServicesNaturopath: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesNaturopath']),
      false
    ),
    professionalServicesSpeechTherapist: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesSpeechTherapist']),
      false
    ),
    professionalServicesMentalHealthOrSupportPractitioner: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'professionalServicesMentalHealthOrSupportPractitioner']),
      false
    ),
    infoPhysiotherapistItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoPhysiotherapistItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoPhysiotherapistItems']).toJS(),
      []
    ),
    infoChiropractorItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoChiropractorItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoChiropractorItems']).toJS(),
      []
    ),
    infoChiropodistItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoChiropodistItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoChiropodistItems']).toJS(),
      []
    ),
    infoOsteopathItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoOsteopathItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoOsteopathItems']).toJS(),
      []
    ),
    infoPodiatristItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoPodiatristItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoPodiatristItems']).toJS(),
      []
    ),
    infoAcupuncturistItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoAcupuncturistItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoAcupuncturistItems']).toJS(),
      []
    ),
    infoNaturopathItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoNaturopathItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoNaturopathItems']).toJS(),
      []
    ),
    infoSpeechTherapistItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoSpeechTherapistItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoSpeechTherapistItems']).toJS(),
      []
    ),
    infoMentalHealthOrSupportPractitionerItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoMentalHealthOrSupportPractitionerItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoMentalHealthOrSupportPractitionerItems']).toJS(),
      []
    ),

    // Rehabilitation Treatment selectors
    infoRehabilitationTreatmentItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoRehabilitationTreatmentItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoRehabilitationTreatmentItems']).toJS(),
      []
    ),

    // Dental Services selectors
    dentalServicesDentalAccident: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalAccident']),
      false
    ),
    dentalServicesImpactedWisdomTooth: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'dentalServicesImpactedWisdomTooth']),
      false
    ),
    dentalServicesDentalPainOther: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalPainOther']),
      false
    ),
    infoDentalAccidentItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoDentalAccidentItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoDentalAccidentItems']).toJS(),
      []
    ),
    infoImpactedWisdomToothItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoImpactedWisdomToothItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoImpactedWisdomToothItems']).toJS(),
      []
    ),
    infoDentalPainOtherItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoDentalPainOtherItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoDentalPainOtherItems']).toJS(),
      []
    ),

    // Prescription Glasses, Contact Lenses or Hearing Aids selectors
    infoPrescriptionGlassesContactLensesHearingAidsItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionGlassesContactLensesHearingAidsItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionGlassesContactLensesHearingAidsItems']).toJS(),
      []
    ),

    // Tutorial Services selectors
    infoTutorialServicesItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoTutorialServicesItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoTutorialServicesItems']).toJS(),
      []
    ),
    infoOtherUnrelatedBenefitItems: mapWithDefault(
      StudentMedicalBenefitsTugoState,
      () => StudentMedicalBenefitsTugoState.getIn(['form', 'infoOtherUnrelatedBenefitItems']) && StudentMedicalBenefitsTugoState.getIn(['form', 'infoOtherUnrelatedBenefitItems']).toJS(),
      []
    ),
  })
);

const makeSelectStudentMedicalBenefitsTugoErrors = () =>
  createSelector(selectStudentMedicalBenefitsTugo, (state) => state.get('errors'));

export {
  makeSelectStudentMedicalBenefitsTugo,
  makeSelectStudentMedicalBenefitsTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StudentMedicalBenefits/selectors.js